import { render } from "./show.vue?vue&type=template&id=1c7a7d59&ts=true"
import script from "./show.vue?vue&type=script&lang=ts"
export * from "./show.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__